import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, EditIcon, Text } from '@mercai/clever'
import { CustomAccordion } from '@/components'

import { ProfileDirectionsProps } from './directions.type'
import styles from './directions.module.css'

export const ProfileDirections = ({
  profile,
  onClickEdit,
}: ProfileDirectionsProps) => {
  const { t } = useTranslation('screenProfileShow')

  const [activeItems, setActiveItems] = useState(['directions'])

  return (
    <div className={styles.core}>
      <CustomAccordion
        activeItems={activeItems}
        setActiveItems={setActiveItems}
        id="directions"
        title={`4. ${t('generalViewGeneralInformationDirectionsTitle')}`}
        // isComplete={}
      >
        <div className={styles['info-block']}>
          {profile?.addresses.map((address, index) => (
            <div key={address.uuid} className={styles['info-row']}>
              <div className={styles['info-row-content']}>
                <Text className={styles['info-item']}>
                  <strong>
                    {t('generalViewDirectionsDirectionLabel')} {index + 1}:
                  </strong>{' '}
                  {address
                    ? [
                        address.street,
                        address.number,
                        address.complement,
                        address.neighborhood,
                        address.state,
                        address.country,
                      ]
                        .filter((item) => item)
                        .join(', ')
                    : ''}
                </Text>
              </div>

              <Button
                variant="secondary"
                className={styles.edit}
                size="small"
                onClick={onClickEdit}
              >
                <EditIcon />
              </Button>
            </div>
          ))}
        </div>
      </CustomAccordion>
    </div>
  )
}
